import styled, { css } from 'styled-components'

export const AboutUsContent = styled.div`
  padding: 0 10px 10px;
  font-size: 15px;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.black};
  text-align: ${({ theme }) => theme.rtl ? 'right' : 'left'};
  direction: ${({ theme }) => theme.rtl ? 'rtl' : 'ltr'};
  word-break: break-word;
  overflow-wrap: anywhere;

  p {
    margin: 0 0 14px;
  }

  ol, ul {
    margin: 0 0 14px;
    ${({ theme }) => theme.rtl ? css`
      padding-right: 20px;
      padding-left: 0;
    ` : css`
      padding-left: 20px;
      padding-right: 0;
    `}
  }

  li {
    margin-bottom: 8px;
  }

  strong {
    color: ${({ theme }) => theme.colors.primaryButtCol};
  }
`

export const AboutUsLoading = styled.div`
  display: flex;
  justify-content: center;
  padding: 30px 0;
`
